import request from '@/utils/request'

export const apiGetPlatformProductPageList = data => {
	return request({
		method: 'post',
		url: '/monitor/platform/product/list',
		data,
	})
}

export const apiFindPlatformProduct = appId => {
	return request({
		method: 'post',
		url: `/monitor/platform/product/find?appId=${appId}`,
	})
}

export const apiCreatePlatformProduct = data => {
	return request({
		method: 'post',
		url: '/monitor/platform/product',
		data,
	})
}

export const apiGetDeviceGroupPageList = data => {
	return request({
		method: 'post',
		url: '/monitor/device-group/list',
		data,
	})
}

export const apiCreateImeiModule = data => {
	return request({
		method: 'post',
		url: '/monitor/device-imei-regist/regist',
		data,
	})
}

export const apiUnRegisterImeiModule = data => {
	return request({
		method: 'put',
		url: '/monitor/device-imei-regist/unregist',
		data,
	})
}

export const apiGetModulePageList = data => {
	return request({
		method: 'post',
		url: '/monitor/report/device-imei-regist/preview',
		data,
	})
}

export const apiDeleteDeviceGroup = params => {
	return request({
		method: 'post',
		url: '/monitor/device-group/delete',
		params,
	})
}

export const apiDeletePlatformProduct = params => {
	return request({
		method: 'post',
		url: '/monitor/platform/product/delete',
		params,
	})
}

export const apiUpdatePlatformProduct = data => {
	return request({
		method: 'put',
		url: '/monitor/platform/product',
		data,
	})
}

export const apiGetOperateLogPageList = data => {
	return request({
		method: 'post',
		url: '/monitor/imei/log/list',
		data,
	})
}

export const apiGetPlatfromProductDetails = platformId => {
	return request({
		method: 'get',
		url: `/monitor/platform/product/${platformId}`,
	})
}

export const apiGetDeviceGroupDetails = id => {
	return request({
		method: 'get',
		url: `/monitor/device-group/${id}`,
	})
}

export const apiCreateDeviceGroup = data => {
	return request({
		method: 'post',
		url: '/monitor/device-group',
		data,
	})
}

export const apiUpdateDeviceGroup = data => {
	return request({
		method: 'put',
		url: '/monitor/device-group',
		data,
	})
}

export const apiUpdateDeviceGroupStatus = data => {
	return request({
		method: 'post',
		url: '/monitor/device-group/update-status',
		data,
	})
}

export const apiGetImeiModuleDetails = id => {
	return request({
		method: 'get',
		url: `/monitor/device-imei-regist/${id}`,
	})
}

export const apiDeviceImeiRegistTask = data => {
	return request({
		method: 'post',
		url: '/monitor/device-imei-regist/task/file',
		data,
	})
}

export const apiGetDeviceImeiRegistTaskList = data => {
	return request({
		method: 'post',
		url: '/monitor/device-imei-regist/task/list',
		data,
	})
}

export const apiGetDeviceImeiRegistTaskDetails = taskId => {
	return request({
		method: 'get',
		url: `/monitor/device-imei-regist/task/${taskId}`,
	})
}

export const apiGetDeviceImeiRegistList = data => {
	return request({
		method: 'post',
		url: '/monitor/report/device-imei-regist/taskdetail/preview',
		data,
	})
}

export const apiCancelDeviceImeiRegistTask = data => {
	return request({
		method: 'put',
		url: '/monitor/device-imei-regist/task',
		data,
	})
}

export const apiExportFailDetails = data => {
	return request({
		method: 'post',
		url: '/monitor/report/device-imei-regist/taskdetail/export/excel',
		data,
		responseType: 'blob',
	})
}
